import { render, staticRenderFns } from "./CTitleSmall.vue?vue&type=template&id=45af4b0c&scoped=true&"
import script from "./CTitleSmall.vue?vue&type=script&lang=js&"
export * from "./CTitleSmall.vue?vue&type=script&lang=js&"
import style0 from "./CTitleSmall.vue?vue&type=style&index=0&id=45af4b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af4b0c",
  null
  
)

export default component.exports